import { useEffect } from 'react';

import { useGlobalStore } from '@store';

const MEDALLIA_SCRIPT_URL = 'https://nebula-cdn.kampyle.com/au/wau/202435/onsite/embed.js';

export const useMedalliaScript = () => {
  const isMedalliaLoaded = useGlobalStore(state => state.isMedalliaLoaded);
  const handleIsMedalliaLoaded = useGlobalStore(state => state.setIsMedalliaLoaded);

  useEffect(() => {
    if (isMedalliaLoaded) {
      return;
    }

    const scriptElem = document.createElement('script');
    scriptElem.setAttribute('src', MEDALLIA_SCRIPT_URL);
    document.body.appendChild(scriptElem);

    handleIsMedalliaLoaded(true);
  }, [isMedalliaLoaded, handleIsMedalliaLoaded]);

  return { isMedalliaLoaded };
};
